import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { PersonRegisteredUsersRequest } from "./person-registered-users-request";
import { PortalNotificationQueueSendMessageRequest } from "./portal-notification-queue-send-message-request";
@Injectable()
export class DataService_Staff_Notifications {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	PersonRegisteredUsersSelectList(parms: PersonRegisteredUsersRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PersonRegisteredUsersSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PortalNotificationQueueSendMessage(parms: PortalNotificationQueueSendMessageRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PortalNotificationQueueSendMessage";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
